<template>
    <div
        class="HorizontalMenu"
        @click.stop="toggleDropdown"
    >
        <StreamlineIcon
            :class="['HorizontalMenu__icon', !open && 'HorizontalMenu__icon--closed']"
            :icon="button.icon"
            :stroke="button.stroke"
            :fill="button.fill"
            :size="16"
        />
        <div
            v-if="open"
            class="HorizontalMenu__dropdown"
        >
            <!-- @slot The content of the dropdown menu -->
            <slot></slot>
        </div>
    </div>
</template>
<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {NavigationMenuHorizontal} from "@reviewpush/streamline-regular/lib/interface-essential/Menu";
import {RemoveCircleBold} from "@reviewpush/streamline-bold/lib/interface-essential/RemoveAdd";
import {textGrey, textLink, white} from 'style/_colors.scss';

export default {
    name: 'RPHorizontalMenu',
    components: {
        StreamlineIcon
    },
    data(){
        return {
            open: false,
        };
    },
    computed: {

        button(){
            return this.open
                ? {
                    fill: textLink,
                    stroke: white,
                    icon: RemoveCircleBold,
                }
                : {
                    fill: textGrey,
                    stroke: textGrey,
                    icon: NavigationMenuHorizontal,
                };
        },
    },
    mounted(){
        document.addEventListener('click', this.hideDropdown);
    },
    destroyed(){
        document.removeEventListener('click', this.hideDropdown);
    },
    methods: {
        toggleDropdown(){
            this.open = !this.open;
        },
        hideDropdown(e){
            if(!this.$el.contains(e.target)) {
                this.open = false;
            }
        }
    }
};
</script>
<style lang="scss">
    .HorizontalMenu {
        width: 1rem;
        height: 1rem;
        position: relative;
        &__icon {
            background: white;
            border-radius: 50%;
            position: relative;
            cursor: pointer;
            z-index: 3;
            &--closed {
                z-index: 1;
            }
        }
        &__dropdown {
            z-index: 2;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
            position: absolute;
            background: $white;
            border: 1px solid $grey-100;
            box-sizing: border-box;
            border-radius: 4px;
            top: .5rem;
            right: 0.5rem;
        }
    }
</style>

<docs>
```vue
<RPHorizontalMenu>
    <template>
        <p>Ornare sociis tempor condimentum quis elementum vivamus pulvinar senectus convallis</p>
    </template>
</RPHorizontalMenu>
```
</docs>
